'use strict';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import * as T from 'prop-types';
import React, {Component} from 'react';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/take';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {FilterInputView} from './FilterInputView';


export class FilterInputComponent extends Component {
  static propTypes = {
    initialFilter: T.string,
    autoFilter: T.string,
    filterModalOptions: T.object,
    onFilterChange: T.func,
    onChangeDebounce: T.number,
    onFilterOptionsUpdate: T.func,
    onSortOptionsUpdate: T.func,
    onUpdateMatchesDefaultOptions: T.func,
    searchOnly: T.bool,
    showFilterOptions: T.bool,
  };

  static MAX_DELAY = 300;

  static $inject = [
    '$modal',
  ];

  constructor(props) {
    super(props);
    this.state = {
      model: props.initialFilter || '',
      editedAt: null,
      isFocused: false,
      matchesDefaultOptions: FilterInputComponent.getNextMatches(props),

      isAnimating: false,
    };
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleOpenFilterOptions = this.handleOpenFilterOptions.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
  }

  handleFilterChange(e) {
    const newText = e.target.value;
    this.setState({model: newText, editedAt: Date.now()});

    if (this.filter$ !== null) {
      this.filter$.next(newText);
    } else if (isFunction(this.props.onFilterChange)) {
      this.props.onFilterChange(newText);
    }
  }

  handleInputBlur() {
    this.setState({isFocused: false});
  }

  handleInputFocus() {
    this.setState({isFocused: true});
  }

  render() {
    return (
      <FilterInputView
        model={this.state.model}
        isFocused={this.state.isFocused}
        searchOnly={this.props.searchOnly}
        isAnimating={this.state.isAnimating}
        matchesDefaultOptions={this.state.matchesDefaultOptions}

        onFilterChange={this.handleFilterChange}
        onClickFilterOptions={this.handleOpenFilterOptions}
        onInputBlur={this.handleInputBlur}
        onInputFocus={this.handleInputFocus}
      />
    );
  }

  withNextFilterModalOptions(props) {
    const filterModalOptions = props.filterModalOptions;
    if (this.matchesDefaultOptions$ && this.filterModalOptions !== filterModalOptions) {
      const matchesDefaultOptions = FilterInputComponent.getNextMatches(props);
      this.matchesDefaultOptions$.next(matchesDefaultOptions);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.autoFilter !== nextProps.autoFilter) {
      const nextState = FilterInputComponent.getFilterState(nextProps, this.state);
      if (nextState !== null) {
        this.setState(nextState);
      }
    }

    this.withNextFilterModalOptions(nextProps);
  }

  componentDidMount() {
    if (isNumber(this.props.onChangeDebounce) && this.props.onChangeDebounce > 0) {
      this.filter$ = new Subject();
      this.filterSubscription = this.filter$
        .distinctUntilChanged()
        .debounceTime(this.props.onChangeDebounce)
        .subscribe(newText => isFunction(this.props.onFilterChange) ? this.props.onFilterChange(newText) : null);
    } else {
      this.filter$ = null;
    }

    this.matchesDefaultOptions$ = new Subject();

    this.stateSubscription = FilterInputComponent.buildState$(this.matchesDefaultOptions$)
      .subscribe(nextState => this.setState(nextState));

    this.withNextFilterModalOptions(this.props);
  }

  componentWillUnmount() {
    this.matchesDefaultOptions$ = null;
    this.stateSubscription && this.stateSubscription.unsubscribe();
    this.filterSubscription && this.filterSubscription.unsubscribe();
  }

  showFilterOptions() {
    return this.state.model && this.props.showFilterOptions;
  }

  handleOpenFilterOptions() {
    return FilterInputComponent.dependencies.$modal.show(this.props.filterModalOptions).then(result => {
      if (isFunction(this.props.onFilterOptionsUpdate)) {
        this.props.onFilterOptionsUpdate(result.filterOptions);
      }

      if (isFunction(this.props.onSortOptionsUpdate)) {
        this.props.onSortOptionsUpdate(result.sortOptions);
      }

      return result;
    });
  }

  static buildState$(matchesDefaultOptions$) {
    return matchesDefaultOptions$
      .distinctUntilChanged()
      .mergeMap(matchesDefaultOptions =>
        matchesDefaultOptions
          ? Observable.of({matchesDefaultOptions})
          : Observable
            .merge(
              Observable.of({matchesDefaultOptions, isAnimating: true}),
              Observable.timer(1000)
                .take(1)
                .mapTo({isAnimating: false}),
            )
      );
  }

  static getFilterState(props, state) {
    if (!isString(props.autoFilter)) {
      return null;

    } else if (state.editedAt !== null && Date.now() - state.editedAt < FilterInputComponent.MAX_DELAY) {
      return state.model === props.autoFilter ? {
        model: props.autoFilter,
        editedAt: null,
      } : null;

    } else {
      return {
        model: props.autoFilter,
      };
    }
  }

  static getNextMatches(props) {
    if (props.searchOnly)
      return true;

    const filterOptions = props.filterModalOptions ? props.filterModalOptions.locals.filterOptions : null;
    const sortOptions = props.filterModalOptions ? props.filterModalOptions.locals.sortOptions : null;
    let filterMatches;
    let sortMatches;

    if (filterOptions) {
      if (isFunction(props.filterModalOptions.isDefaultFilterOptions)) {
        filterMatches = props.filterModalOptions.isDefaultFilterOptions(filterOptions);
      }
    } else {
      filterMatches = true;
    }

    if (sortOptions) {
      if (props.filterModalOptions.locals.defaultSortOptions) {
        sortMatches = isEqual(props.filterModalOptions.locals.defaultSortOptions, sortOptions);
      }
    } else {
      sortMatches = true;
    }

    return filterMatches && sortMatches;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/lists/FilterInput/FilterInputComponent.js